import { z } from 'zod';

const FraudAlertSeveritySchema = z.enum(['LOW', 'MEDIUM', 'HIGH', 'CRITICAL']);
const FraudAlertStatusSchema = z.enum(['PENDING', 'APPROVED', 'REJECTED', 'AUTO_RESOLVED']);

export const AdminFraudAlertSchema = z.object({
  id: z.string(),
  wristbandId: z.string().nullable(),
  customerId: z.string().nullable(),
  alertType: z.string(),
  severity: FraudAlertSeveritySchema,
  reason: z.string(),
  metadata: z.record(z.unknown()).nullable(),
  status: FraudAlertStatusSchema,
  reviewedBy: z.string().nullable(),
  reviewedAt: z.string().nullable(),
  reviewNote: z.string().nullable(),
  detectedAt: z.string(),
  createdAt: z.string(),
});
export type AdminFraudAlert = z.infer<typeof AdminFraudAlertSchema>;

export const AdminFraudSummarySchema = z.object({
  pending: z.number().int(),
  approved: z.number().int(),
  rejected: z.number().int(),
  autoResolved: z.number().int(),
  bySeverity: z.object({
    LOW: z.number().int(),
    MEDIUM: z.number().int(),
    HIGH: z.number().int(),
    CRITICAL: z.number().int(),
  }),
});
export type AdminFraudSummary = z.infer<typeof AdminFraudSummarySchema>;

export const AdminFraudListResponseSchema = z.object({
  alerts: z.array(AdminFraudAlertSchema),
  total: z.number().int(),
  page: z.number().int(),
  limit: z.number().int(),
  totalPages: z.number().int(),
});
export type AdminFraudListResponse = z.infer<typeof AdminFraudListResponseSchema>;

export const AdminFraudListQuerySchema = z.object({
  page: z.coerce.number().int().positive().optional(),
  limit: z.coerce.number().int().positive().max(100).optional(),
  status: FraudAlertStatusSchema.optional(),
  severity: FraudAlertSeveritySchema.optional(),
  alertType: z.string().optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
});
export type AdminFraudListQuery = z.infer<typeof AdminFraudListQuerySchema>;

export const AddAdminFraudNoteSchema = z.object({
  note: z.string().min(1).max(2000),
});
export type AddAdminFraudNoteInput = z.infer<typeof AddAdminFraudNoteSchema>;
